import './App.css';
import React, {useState} from "react";
import LoginPage from "./Pages/Login/LoginPage"

console.log(`App.js: environment:${process.env.NODE_ENV}`);
console.log(`App.js: REACT_APP_API_URL:${process.env.REACT_APP_API_URL}`);

function App() {

  return (

    <div className="App">
      <LoginPage />
    </div>

  );
}

export default App;
